<template>
  <div class="project-feedback">
    <div v-if="step>=6" class="project-step-box">
      <p class="project-step-title">开票催款阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">开票催款:</span><span>{{toworks.length}}人</span>
        </p>
        <div class="feedback-table-box">
          <FeedBackSummaryTable v-for="item in toworks" :key="item._id"
                                :rid="item.rid"
                                :name="item.towork&&item.towork.候选人"
                                :company="item.radish&&item.radish.公司"
                                :tag="`${item.状态&&item.状态.tag}`"
                                :date="dateFormat(item.updatedAt, 'yyyy-mm-dd')"
                                @showRadishProgress="showRadishProgress"></FeedBackSummaryTable>
        </div>
      </div>
    </div>
    <div v-if="step>=5" class="project-step-box">
      <p class="project-step-title">离职管理阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">离职管理:</span><span>{{leave.length}}人</span>
        </p>
        <div class="feedback-table-box">
          <FeedBackSummaryTable v-for="item in leave" :key="item._id"
                                :rid="item.rid"
                                :name="item.leave&&item.leave.候选人"
                                :company="item.radish&&item.radish.公司"
                                :tag="`${item.状态&&item.状态.tag}`"
                                :date="dateFormat(item.updatedAt, 'yyyy-mm-dd')"
                                @showRadishProgress="showRadishProgress"></FeedBackSummaryTable>
        </div>
      </div>
    </div>
    <div v-if="step>=4" class="project-step-box">
      <p class="project-step-title">offer谈判阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">offer谈判:</span><span>{{maybeOffers.length}}人</span>
        </p>
        <div class="feedback-table-box">
          <FeedBackSummaryTable v-for="item in maybeOffers" :key="item._id"
                                :rid="item.rid"
                                :name="item.maybeOffer&&item.maybeOffer.候选人"
                                :company="item.radish&&item.radish.公司"
                                :tag="`${item.状态&&(item.状态.tag==='面试'?'终面':item.状态.tag)}`"
                                :date="dateFormat(item.updatedAt, 'yyyy-mm-dd')"
                                @showRadishProgress="showRadishProgress"></FeedBackSummaryTable>
        </div>
      </div>
      <div class="progress-box">
        <div v-for="(item,index) in project.项目offer反馈" :key="index" class="progress-item">
          <span class="progress-item-date mr10">{{ dateFormat(item.createdAt) }}</span>
          <span class="progress-item-user mr5">{{ item.user }}</span>
          <span class="progress-item-content">
            <p class="flex-none mr10">填写<span class="ml5 virtual-btn">推荐人选反馈</span></p>
            <p class="black">{{item.content}}</p>
          </span>
        </div>
      </div>
    </div>
    <div v-if="step>=3" class="project-step-box">
      <p class="project-step-title">面试阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">面试:</span><span>{{interviews.length}}人</span>
        </p>
        <div class="feedback-table-box">
          <FeedBackSummaryTable v-for="item in interviews" :key="item._id"
                                :rid="item.rid"
                                :name="item.interview&&item.interview.候选人"
                                :company="item.radish&&item.radish.公司"
                                :tag="`${item.状态&&item.状态.tag}（${item.状态&&item.状态.detail}）`"
                                :date="dateFormat(item.updatedAt, 'yyyy-mm-dd')"
                                @showRadishProgress="showRadishProgress"></FeedBackSummaryTable>
        </div>
      </div>
      <div class="progress-box">
        <div v-for="(item,index) in project.客户对项目反馈" :key="index" class="progress-item">
          <span class="progress-item-date mr10">{{ dateFormat(item.createdAt) }}</span>
          <span class="progress-item-user mr5">{{ item.user }}</span>
          <span class="progress-item-content">
            <p class="flex-none mr10">填写<span class="ml5 virtual-btn">推荐人选反馈</span></p>
            <p class="black">{{item.content}}</p>
          </span>
        </div>
      </div>
    </div>
    <div v-if="step>=2" class="project-step-box">
      <p class="project-step-title">职位推荐阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">已推荐:</span><span>{{project.recommends&&project.recommends.length}}人</span>
        </p>
      </div>
      <div class="progress-box">
        <div v-for="(item,index) in project.客户经理人选反馈" :key="index" class="progress-item">
          <span class="progress-item-date mr10">{{ dateFormat(item.createdAt) }}</span>
          <span class="progress-item-user mr5">{{ item.user }}</span>
          <span class="progress-item-content">
            <p class="flex-none mr10">填写<span class="ml5 virtual-btn">推荐人选反馈</span></p>
            <p class="black">{{item.content}}</p>
          </span>
        </div>
      </div>
    </div>
    <div v-if="step>=1" class="project-step-box">
      <p class="project-step-title">人才搜寻阶段</p>
      <div class="project-step-detail-box mb10">
        <p class="ft14">
          <span style="margin-right:10px">符合要求人选:</span><span style="margin-right:30px">{{radishProjectDetail.已搜寻}}人</span>
          <span style="margin-right:10px">已沟通人选:</span><span style="margin-right:30px">{{radishProjectDetail.已沟通}}人</span>
        </p>
        <p class="flex ft14">
          <span class="flex-none mr10">搜索行业：</span>
          <span>{{(radishProjectDetail.行业 || []).join('、')}}</span>
        </p>
        <p class="flex ft14">
          <span class="flex-none mr10">搜索公司：</span>
          <span>{{(radishProjectDetail.公司 || []).join('、')}}</span>
        </p>
      </div>
      <div class="progress-box">
        <el-button v-if="showReportBtn" type="primary" plain size="mini" @click="showRadishSearchMark">查看人才寻访反馈详情</el-button>
        <div v-for="(item,index) in reportHistory" :key="index" class="progress-item">
          <span class="progress-item-date mr10">{{ dateFormat(item.updatedAt) }}</span>
          <span class="progress-item-user mr5">{{ item.account }}</span>
          <span class="progress-item-content">
            填写
            <span class="virtual-btn">人才寻访反馈</span>
          </span>
        </div>
      </div>
    </div>
    <div v-if="step>=0" class="project-step-box">
      <p class="project-step-title">项目创建阶段</p>
      <div class="project-step-detail-box">
        <p class=" ft14">参与成员</p>
        <p class="text-indent ft14">客户开发：{{ (project['客户开发'] || []).join('、') }}</p>
        <p class="text-indent ft14">项目对接：{{ (project['项目对接'] || []).join('、') }}</p>
        <p class="text-indent ft14">项目经理：{{ (project['项目经理'] || []).join('、') }}</p>
        <p class="text-indent ft14">项目成员：{{ (project['项目成员'] || []).join('、') }}</p>
      </div>
      <div class="progress-box">
        <div class="progress-item align-center">
          <span class="progress-item-date mr10">{{ dateFormat(project.createdAt) }}</span>
          <span class="progress-item-user mr5">{{ project.创建人 }}</span>
          <span class="progress-item-content">创建项目</span>
        </div>
      </div>
    </div>
    <!-- components -->
    <RadishProgress ref="RadishProgress"></RadishProgress>
    <NewProjectRadishSearchDialog ref="NewProjectRadishSearchDialog"></NewProjectRadishSearchDialog>
  </div>
</template>

<script>
import NewProjectRadishSearchDialog from './NewProjectRadishSearchDialog.vue'
import FeedBackSummaryTable from './projectProgress/FeedBackSummaryTable'
import RadishProgress from '../../../radish/src/progress/radish-progress'

const dateFormat = require('dateformat')

export default {
  components: { NewProjectRadishSearchDialog, FeedBackSummaryTable, RadishProgress },
  props: {
    pid: { type: String, default: '' },
  },
  data() {
    return {
      project: {},
      loading: false,
      showReportBtn: false,
      radishProjectDetail: {},
      reportHistory: [],
      progress: {},
      interviews: [],
      maybeOffers: [],
      leave: [],
      toworks: [],
    }
  },
  computed: {
    step() {
      const steps = ['项目创建', '人才搜索', '职位推荐', '面试阶段', 'offer谈判', '离职管理', '开票催款']
      const index = steps.findIndex(val => this.project.项目阶段 === val)
      return index !== -1 ? index : 0
    },
  },
  watch: {
    pid: {
      handler(newValue, oldValue) {
        if (newValue) this.loadData()
      },
      immediate: true,
    },
  },

  methods: {
    showRadishProgress(rid) {
      this.$refs.RadishProgress.open({ pid: this.project._id, rid: rid, logOnly: false })
    },
    showRadishSearchMark(project) {
      this.$refs.NewProjectRadishSearchDialog.open(this.project)
    },
    async loadData() {
      this.loading = true
      try {
        const project = await window.app.service('project').fetch(this.pid)
        this.project = project
        this.getProjectsPipelines()
      } catch (error) {
        this.$message.error(error.message)
      }
      this.loading = false
    },
    async getProjectsPipelines(projects) {
      try {
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids: [this.pid],
        })
        Object.assign(this.project, data[0])
        this.getPipeline = true
        this.init()
      } catch (e) {
        console.error(e)
      }
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    init() {
      this.countRadishes()
      this.countInterviews()
      this.countMaybeOffers()
      this.countLeave()
      this.countToworks()
      this.loadProjectReport()
    },
    async countToworks() {
      const radishProject = this.project.radish_project || []
      const toworks = this.project.toworks || []
      const list = radishProject.filter(v => v.状态 && (v.状态.tag === '到岗' || v.状态.tag === '过保'))
      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          ele.towork = toworks.find(v => v.rid === ele.rid) || {}
          ele.radish = res.data.find(v => v._id === ele.rid)
        })
        this.toworks = list
      }
    },
    async countLeave() {
      const radishProject = this.project.radish_project || []
      const offers = this.project.offers || []
      const list = radishProject.filter(v => v.状态 && v.状态.tag === 'offer')
      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          ele.leave = offers.find(v => v.rid === ele.rid) || {}
          ele.radish = res.data.find(v => v._id === ele.rid)
        })
        this.leave = list
      }
    },
    async countMaybeOffers() {
      const radishProject = this.project.radish_project || []
      const interviews = this.project.interviews || []
      const offers = this.project.offers || []
      const list = radishProject.filter(
        v => v.状态 && ((v.状态.tag === '面试' && v.状态.detail === '终面') || v.状态.tag === 'offer谈判'),
      )
      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          if (ele.状态.tag === '面试') {
            ele.maybeOffer = interviews.find(v => v.rid === ele.rid && v.isFinal) || {}
          } else {
            ele.maybeOffer = offers.find(v => v.rid === ele.rid) || {}
          }
          ele.radish = res.data.find(v => v._id === ele.rid)
        })
        this.maybeOffers = list
      }
    },
    async countInterviews() {
      const radishProject = this.project.radish_project || []
      const interviews = this.project.interviews || []
      interviews.sort((a, b) => b.round - a.round)
      const list = radishProject.filter(v => v.状态 && v.状态.tag === '面试' && v.状态.detail !== '淘汰')

      const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      if (res.status === 'success') {
        list.forEach(ele => {
          ele.radish = res.data.find(v => v._id === ele.rid)
          ele.interview = interviews.find(v => v.rid === ele.rid) || {}
        })
        this.interviews = list
      }
    },
    async loadProjectReport() {
      try {
        const data = await app.service('project').fetchProjectReport({ pid: this.project._id })
        this.reportHistory = (data && data.updatedBy) || []
        const fields = ['不考虑的原因', '市场情况', '阿尔法建议']
        let flag = false
        fields.forEach(field => {
          if (data[field]) flag = true
        })
        this.showReportBtn = flag
      } catch (e) {
        console.error(e)
      }
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
  },
}
</script>

<style scoped>
.project-feedback {
  padding: 10px 170px;
}
.project-step-box {
  margin-bottom: 20px;
}
.project-step-title {
  font-size: 16px;
  margin: 4px 0;
  display: flex;
  align-items: center;
}
.project-step-title::before {
  content: '';
  display: inline-block;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #666;
  margin-right: 4px;
}
.project-step-detail-box {
  background-color: #eee;
  border-radius: 5px;
  padding: 8px 20px;
}
.project-step-detail-box p {
  margin: 4px;
}
.bolder {
  font-weight: 800;
}
.text-indent {
  text-indent: 2em;
}
.progress-item {
  margin-bottom: 4px;
  display: flex;
}
.progress-item-date {
  flex: none;
}
.progress-item-date::before {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #666;
  margin-right: 4px;
}
.progress-item-user {
  color: #409eff;
  word-break: keep-all;
}
.progress-item-content {
  padding-left: 10px;
  flex-grow: 1;
}
.flex {
  display: flex;
}
.flex-none {
  flex: none;
}
.progress-item-date,
.progress-item-user,
.progress-item-content {
  height: 24px;
  display: flex;
  align-items: center;
  color: #a8a4a4;
}
.ml5 {
  margin-left: 5px;
}
.align-center {
  align-items: center;
}

.virtual-btn {
  padding: 4px 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  display: inline-block;
}
.feedback-table-box {
  display: flex;
  flex-wrap: wrap;
}
.project-step-detail-box {
  margin-left: 20px;
}
.progress-box {
  padding-left: 20px;
}
.ft14 {
  font-size: 14px;
}
.black {
  color: #000;
}
</style>
